// extracted by mini-css-extract-plugin
export default {"container":"list_container__zB+cm","search":"list_search__4iQu2"};